import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import * as d3 from "d3";
import HoverableIcon from "../Buttons/HoverableIcon ";
import { store } from "../../util/store";
import ReusableAgGrid from "../AgGrid/AgGrid";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  titleContainer: {
    width: "100%",
  },
}));

const DrilldownBody = (props) => {
  const [exportTrigger, setExportTrigger] = useState(0); // Each time we click, the number changes, triggering the useEffect in the child.

  const classes = useStyle();

  const state = store.getState();
  const Currency_Symbol = state.app.user.Currency;

  const onCellClicked = (e) =>
    props.handleSecondLevelDrilldown("drilldownOppId", e.data.Opp_ID);

  const handleExport = () => {
    // Each time we click, the number changes, triggering the useEffect in the child.
    setExportTrigger((prevCount) => prevCount + 1);
  };

  return (
    <Grid container className={classes.root}>
      {props.body ? (
        <React.Fragment>
          <Grid
            container
            justify="space-betweeen"
            className={classes.titleContainer}
            xs={12}
          >
            <Grid
              item
              container
              xs={10}
              justify="flex-start"
              alignItems="flex-end"
            >
              <Typography variant="body1" style={{ fontWeight: "600" }}>
                Number of opportunities:{" "}
                <span data-test="count">
                  {d3.format(",")(props.body.count_acv[0].count)}
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {props.Value_Label}:
                {`${Currency_Symbol}`}{" "}
                <span data-test="acv">
                  {d3.format(",")(
                    Math.round(props.body.count_acv[0].total_acv).toString()
                  )}
                </span>
              </Typography>
            </Grid>
            <Grid
              direction="column"
              item
              container
              xs={2}
              justify="flex-end"
              alignItems="flex-end"
              alignContent="flex-end"
            >
              <Grid item justify="flex-end" style={{ paddingBottom: "1rem" }}>
                <button style={{ border: "none" }} onClick={handleExport}>
                  <HoverableIcon />
                </button>
              </Grid>
            </Grid>
          </Grid>

          <ReusableAgGrid
            rowData={props.body.opportunities}
            columnConfig={props.body.columns}
            onCellClicked={onCellClicked}
            isExportable={true}
            header={props.header}
            rawColumnDataForExport={props.body.columns}
            exportTrigger={exportTrigger}
          />
        </React.Fragment>
      ) : (
        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={280}
          style={{ margin: "20px 0px" }}
        />
      )}
    </Grid>
  );
};

export default DrilldownBody;
